import React, { useState } from "react";
import { useRequest } from "../../../hooks/useRequest";
import styled from "styled-components";
import { loginUserObj } from "../../../utils/constants";
import { toast } from "react-toastify";
import Progress from "../../common/Progress";
import { useAppContext } from "../../../context/useAppContext";
import { useNavigate } from "react-router-dom";

const PasswordStyle = styled.div`
  color: #ff0000;
  font-size: 12px;
  margin-top: 6px;
`;

const Reset = ({ setIsResetForm }) => {
  const [loginType, setLoginType] = useState("email");
  const [login, { isLoading }] = useRequest();

  const [error, setError] = useState({
    username: false,
    password: false,
  });

  const [userInfo, setUserInfo] = useState(loginUserObj);
  const { setUser } = useAppContext();
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (!userInfo.username) {
      if (!userInfo.username) {
        setError((prev) => ({ ...prev, username: true }));
      }
      return;
    }
    const path = `/auth/reset-password`;
    const response = await login({
      path,
      method: "POST",
      body: JSON.stringify({email: userInfo.username}),
    });
    if (!response.success) {
      return toast.error(response.message);
    }
    toast.success(response.message);
    navigate("/");
    setIsResetForm(false);
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setUserInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  return (
    <>
      <div className="auth__form__title">Reset</div>
      <div className="auth__form__subtitle">
        Enter your email to reset your password
      </div>
      <form onSubmit={handleSignIn} className="auth__form__body">
        <div className="auth__form__group">
          <label>
            Email Address
          </label>
          <input
            type={'email'}
            name="username"
            value={userInfo?.username}
            pattern={
              loginType !== "email"
                ? "/d*"
                : "[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$"
            }
            className={`auth__form__input ${error?.username && "error"}`}
            onChange={handleChange}
          />
          {error?.username && <PasswordStyle>Email is required.</PasswordStyle>}
        </div>
        <div className="auth__form__button">
          <button type="submit">Get Reset Link</button>
        </div>
      </form>
      {isLoading && <Progress />}
    </>
  );
};

export default Reset;
